import { jsx, jsxs } from 'react/jsx-runtime';
import { useLocalization } from '@shared-ui/localization-context';
import * as React from 'react';
import '../../layout-flex/types/index.esm.js';
import { EGDSLayoutFlex } from '../../layout-flex/layout-flex/index.esm.js';
import '../../layout-flex/layout-flex-item/index.esm.js';
import { EGDSIcon, EGDSIconSize } from '../../icons/icon/index.esm.js';
import { EGDSActionList } from '../../action-list-item/action-list/index.esm.js';
import { EGDSActionListItem } from '../../action-list-item/action-list-item/index.esm.js';
import '../../action-list-item/action-list-item-link/index.esm.js';
import '../../text/types/index.esm.js';
import '../../text/heading/index.esm.js';
import '../../text/paragraph/index.esm.js';
import '../../text/subheading/index.esm.js';
import { EGDSText } from '../../text/text/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import '../../spacing/types/index.esm.js';
import { EGDSSpacing } from '../../spacing/spacing/index.esm.js';
import '../../spacing/spacing-hr/index.esm.js';
import '../../skeleton/skeleton/index.esm.js';
import '../../skeleton/skeleton-block/index.esm.js';
import { EGDSLineSkeleton } from '../../skeleton/skeleton-line/index.esm.js';
import { TypeaheadLocationType } from '../adapters/ess-adapter/index.esm.js';
import '../adapters/google-adapter/index.esm.js';
import '../adapters/mapbox-adapter/index.esm.js';
import { filterTypeaheadResults, getSizeOfTypeaheadResults } from '../adapters/typeahead-results/index.esm.js';
import { EGDSTypeaheadAttribution } from '../typeahead-attribution/index.esm.js';
import { EGDSTypeaheadResultItem } from '../typeahead-result-item/index.esm.js';
import { EGDSTypeaheadSelections } from '../typeahead-selections/index.esm.js';
import styles from '../../styles/uitk-egds-typeahead.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const getResultItemClassName = result => {
  const isCurrentLocation = result && result.data && result.data.type === TypeaheadLocationType.CURRENT_LOCATION;
  const resultItemClassNames = getClassNameList({
    'is-child': result.data && result.isChild,
    'uitk-typeahead-current-location': isCurrentLocation && result.data.enabled,
    disabled: isCurrentLocation && !result.data.enabled
  });
  return resultItemClassNames;
};
const EGDSTypeaheadResults = props => {
  const {
    activeSuggestion,
    allowExactMatch,
    listTitle,
    typeaheadLabel,
    onResultItemSelect,
    results,
    searchTerm,
    stid,
    emptyResultPlaceholder,
    isMulti,
    onClearAll,
    onItemRemove,
    clearAllText,
    selectedItemHeading,
    value,
    domRef,
    contentRef,
    historyDetail
  } = props;
  const l10n = useLocalization();
  const filteredResults = isMulti ? filterTypeaheadResults(results, value) : results;
  const resultsLen = getSizeOfTypeaheadResults(filteredResults);
  const cssClassNames = isMulti ? 'uitk-typeahead-multi-selection-results' : 'uitk-typeahead-results';
  const renderSelections = () => isMulti && value.length > 0 ? jsx(EGDSTypeaheadSelections, {
    typeaheadLabel: typeaheadLabel,
    values: value,
    stid: stid,
    clearAllText: clearAllText,
    onClear: onClearAll,
    onItemRemove: onItemRemove,
    headingText: selectedItemHeading,
    className: getClassNameList('uitk-typeahead-results-selections')
  }) : null;
  if (!results || results.items.length === 0) {
    return emptyResultPlaceholder ? jsx(EGDSSpacing, {
      padding: {
        blockstart: 'three'
      },
      children: jsxs("div", {
        children: [renderSelections(), jsx(EGDSLayoutFlex, {
          justifyContent: "center",
          alignContent: "center",
          className: getClassNameList('uitk-typeahead-empty-state'),
          children: jsxs(EGDSText, {
            align: "center",
            children: [jsx(EGDSSpacing, {
              margin: {
                blockstart: 'six'
              },
              children: jsx(EGDSIcon, {
                name: "search",
                size: EGDSIconSize.XLARGE
              })
            }), jsx(EGDSSpacing, {
              margin: {
                blockend: 'three'
              },
              children: jsx(EGDSText, {
                size: 300,
                children: emptyResultPlaceholder
              })
            })]
          })
        })]
      })
    }) : jsx(EGDSSpacing, {
      padding: {
        blockstart: 'three'
      },
      children: jsx("div", {
        children: renderSelections()
      })
    });
  }
  const handleResultItemSelect = (itemValue, data) => onResultItemSelect(itemValue, data, filteredResults);
  const isTypeaheadResultsLoading = loadingResults => loadingResults[0]?.disabled;
  const isCategorizedResultsLoading = categories => categories[0]?.typeaheadResults[0]?.disabled;
  const isResultsLoading = resultsDropdown => {
    switch (resultsDropdown.type) {
      case 'categorized':
        return isCategorizedResultsLoading(resultsDropdown.items);
      case 'uncategorized':
        return isTypeaheadResultsLoading(resultsDropdown.items);
    }
  };
  const renderSkeletons = () => jsxs("div", {
    className: getClassNameList('uitk-typeahead-results-skeleton-container'),
    children: [jsx(EGDSLineSkeleton, {
      className: getClassNameList('uitk-typeahead-results-skeleton', 'uitk-typeahead-results-skeleton-first')
    }), jsx(EGDSLineSkeleton, {
      className: getClassNameList('uitk-typeahead-results-skeleton', 'uitk-typeahead-results-skeleton-second')
    }), jsx(EGDSLineSkeleton, {
      className: getClassNameList('uitk-typeahead-results-skeleton')
    })]
  });
  const showUnCategorizedResults = typeaheadResults => typeaheadResults && typeaheadResults.map((result, index) => jsxs(React.Fragment, {
    children: [listTitle && jsx(EGDSActionListItem, {
      spacing: "relaxed",
      className: getClassNameList('uitk-typeahead-result-title'),
      children: jsx("div", {
        className: getClassNameList('uitk-typeahead-result-title-label', 'truncate'),
        children: result.title
      })
    }), jsx(EGDSTypeaheadResultItem, {
      className: getResultItemClassName(result),
      data: result.data,
      index: index,
      icon: result.icon,
      name: result.name,
      onResultItemSelect: handleResultItemSelect,
      stid: stid,
      value: result.value,
      subtext: result.subtext,
      activeSuggestion: activeSuggestion !== -1 && activeSuggestion === index,
      contentRef: contentRef,
      historyDetail: historyDetail
    }, index)]
  }, index));
  const showCategorizedResults = categorizedResults => categorizedResults && categorizedResults.map(category => jsxs(React.Fragment, {
    children: [category.heading && jsx(EGDSActionListItem, {
      spacing: "relaxed",
      className: getClassNameList('uitk-typeahead-result-title'),
      children: jsx("div", {
        className: getClassNameList('uitk-typeahead-result-title-label', 'truncate'),
        children: category.heading
      })
    }), category.typeaheadResults && category.typeaheadResults.map((item, index) => jsx(EGDSTypeaheadResultItem, {
      className: getResultItemClassName(item),
      data: item.data,
      index: index,
      icon: item.icon,
      name: item.name,
      onResultItemSelect: handleResultItemSelect,
      stid: stid,
      value: item.value,
      subtext: item.subtext,
      activeSuggestion: activeSuggestion !== -1 && activeSuggestion === item.data?.index,
      historyDetail: historyDetail
    }, index))]
  }, category.heading));
  const showResults = resultsDropdown => {
    switch (resultsDropdown.type) {
      case 'categorized':
        return isCategorizedResultsLoading(resultsDropdown.items) ? renderSkeletons() : showCategorizedResults(resultsDropdown.items);
      case 'uncategorized':
        return isTypeaheadResultsLoading(resultsDropdown.items) ? renderSkeletons() : showUnCategorizedResults(resultsDropdown.items);
    }
  };
  return jsx(EGDSSpacing, {
    padding: {
      blockstart: 'three'
    },
    children: jsxs("div", {
      className: getClassNameList(cssClassNames),
      ref: domRef,
      children: [renderSelections(), jsxs(EGDSActionList, {
        className: getClassNameList('no-bullet'),
        "data-stid": stid && `${stid}-results`,
        children: [showResults(filteredResults), allowExactMatch && searchTerm && !isResultsLoading(filteredResults) && jsx(EGDSTypeaheadResultItem, {
          icon: "search",
          name: l10n.formatText('typeahead.searchFor', [searchTerm]),
          onResultItemSelect: handleResultItemSelect,
          index: resultsLen,
          stid: stid,
          value: searchTerm,
          sanitized: true,
          activeSuggestion: !!(activeSuggestion !== -1 && activeSuggestion === resultsLen),
          historyDetail: historyDetail
        })]
      }), jsx(EGDSTypeaheadAttribution, {
        results: filteredResults
      })]
    })
  });
};
export { EGDSTypeaheadResults };